import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { useTranslation } from 'react-i18next';
import { OrderData } from '../../../api';
import { BODY_WEIGHT, FONT_SIZE, ICON_SIZE, MUTED_TEXT } from '../agendaStyles';
import { formatSeconds } from '../utils/areasFormat';

type AgendaDragPreviewProps = {
  order: OrderData;
  timeFormat: string;
};

export const AgendaDragPreview = ({ order, timeFormat }: AgendaDragPreviewProps) => {
  const { t } = useTranslation();
  const startSeconds = order.time ?? 0;
  const name = [order.firstname, order.lastname].filter(Boolean).join(' ');
  const timeRange = `${formatSeconds(startSeconds, timeFormat)}–${formatSeconds(
    startSeconds + order.duration,
    timeFormat,
  )}`;

  return (
    <Paper
      variant="outlined"
      sx={{
        width: '240px',
        padding: '8px 12px',
        cursor: 'grabbing',
        borderRadius: '8px',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
      }}>
      <Typography
        sx={{
          fontSize: FONT_SIZE.title,
          fontWeight: 700,
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
        }}>
        {name || t('calendar.areas_view.unnamed_order')}
      </Typography>
      <Grid container alignItems="center" gap={1.5} wrap="nowrap">
        <Typography dir="ltr" sx={{ fontSize: FONT_SIZE.detail, fontWeight: BODY_WEIGHT, color: MUTED_TEXT }}>
          {timeRange}
        </Typography>
        <Grid container alignItems="center" gap={0.5} wrap="nowrap" sx={{ width: 'auto' }}>
          <PeopleAltOutlinedIcon sx={{ fontSize: ICON_SIZE, color: MUTED_TEXT }} />
          <Typography dir="ltr" sx={{ fontSize: FONT_SIZE.secondary, fontWeight: BODY_WEIGHT }}>
            {order.persons}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};
